import { render } from "./Conversation.vue?vue&type=template&id=db2e624a&ts=true"
import script from "./Conversation.ts?vue&type=script&lang=ts&external"
export * from "./Conversation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__